<template>
  <div id="app">
    <router-view/>
    <div id='pub-footer'>
      <div id="pub_footers" class="foall">
        <div class="center">
          <div class="f_nav fl">
          </div>
          <div class="f_kefu fr">
            <a target="_blank" href="//wpa.b.qq.com/cgi/wpa.php?ln=1&amp;key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf">客服QQ：800103377</a> |
            <a>客服邮箱：service#zhaouc.com (使用时将#号改为@)</a>
          </div>
        </div>
      </div>
      <div id="pub_footer">
        <div class="center">
          <div class="f_main fl">
            <div class="f_group_logo">
              <ul class="f_group_logo_list">
                <li>
                  <a class="gl_taren" title="塔人网络"></a>
                </li>
                <li>
                  <a class="gl_"></a>
                </li>
              </ul>
            </div>
            <div class="f_net_info">
              <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防上当受骗。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
            </div>
            <div class="f_new_copyright">
              <p>Copyright  2008-2017 Www.Zhaouc.Com All rights reserved. | 地址：上海市浦东新区峨山路505号东方纯一大厦9层 | 电话：021-50895215</p>
              <p>
                <a>电信增值业务经营许可证：沪B2-20150148</a> |
                <a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备11030533号</a>
              </p>
              <p>本公司网络游戏适合年龄18周岁以上的用户使用，请您确定已如实进行实名注册，为了您的健康，请合理控制游戏时间。| 版权所有 上海塔人网络科技股份有限公司</p>
            </div>
            <div class="f_info_index clearfix">
              <p>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502000687" target="_blank"><img src="//res.zhaouc.com/footer/0710/ghs.png">沪公网安备 31011502000687号</a>
              </p>
              <p>
                <a href="//sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/65E2EBD205AB45A5AD85409A987B7374" target="_blank"><img src="//res.zhaouc.com/footer/0710/www.png">沪网文〔2018〕3700-293号</a>
              </p>
              <p>
                <a href="https://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&amp;entyId=dov73ne2cve0r6zyyhpj6l5j4y8i0wcn4g" target="_blank"><img src="//res.zhaouc.com/footer/0710/gs.png">亮照标识 2012011309063431</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue